import PaymentWallButton from './PaymentWallButton';

export default PaymentWallButton;